<template>
  <div class="AvoutContent">
    <div class="pages-content">
      <div class="pages-about-gywm">
        <div class="pages-about-gywm-tu-bj"></div>
        <div class="pages-about-gywm-text">
          <h1>
            {{$t('AboutTitle')}}
          </h1>
          <p
            v-for="(val,index) in Introduces"
            :key="index"
          >
            {{val.Introduce}}
          </p>
        </div>

      </div>
      <!-- 发展历程 -->
      <div class="pages-about-team">
        <h1>
          {{$t("HistoryTitle")}}
        </h1>
        <ul
          class="pages-about-team-ul clearfix"
          v-for="(history,index) in Historys"
          :key="index"
          v-show="history.HoverImg!=''"
        >
          <li>
            <div
              class="text Bg"
              v-lazy:background-image="history.DefaultImg"
            >
              <p
                v-for="(historyText,b) in history.Text"
                :key="b"
                class=""
                :style="{'margin-top':history.MarginTop,'font-size':history.FontSize,'line-height':history.LineHeight,}"
              >
                {{historyText}}
              </p>
            </div>
            <div class="date">
              <p class="month">
                {{history.Month}}
              </p>
              <p class="year">
                {{history.Year}}
              </p>
            </div>
          </li>

        </ul>
      </div>
    </div>

  </div>

</template>

<script>
// import { History } from './js/AboutContentData'
// 鼠标经过
// import { mouseEnter, mouseLeave } from '../../assets/js/hover';
export default {
  name: 'AvoutContent',
  data() {
    return {
      // 管理团队
      // ManageTeam: ManageTeam,
      // 发展历程
      History: '',
    }
  },
  methods: {
    // 鼠标经过
    // mouseenter (index, url) {
    //   mouseEnter(index, url);
    // },
    // mouseleave (index, url) {
    //   mouseLeave(index, url);
    // }
  },
  mounted() {
    // this.Historys.forEach((item, index, arr) => {
    //   if (item.Text.length == 1) {
    //     item.MarginTop = "30px";
    //   }
    // });
    // this.History.reverse();
    const script = document.createElement('script')
    script.src = `https://s2.sonkwostatic.cn/ceasia_hk/js/data/AboutContentData.js?v=${new Date().getTime()}`
    script.onload = () => {
      // eslint-disable-next-line no-undef
      this.History = History
    }
    document.head.appendChild(script)
    window.addEventListener('scroll', this.scrollToTop, true)
  },
  computed: {
    // 介绍的标题
    Introduces() {
      return this.$t('AboutIntroduce')
    },
    // 管理团队
    // ManageTeams () {
    //   let NewManageTeam = ManageTeam.map((value, index, arr) => ({
    //     name: this.$t('AboutManageTeam')[index].name,
    //     post: this.$t('AboutManageTeam')[index].post,
    //     avatar: ManageTeam[index].avatar,
    //     introduce: this.$t('AboutManageTeam')[index].introduce
    //   }));

    //   return NewManageTeam;
    // },
    // 发展历史
    Historys() {
      if (this.History !== '') {
        let NewHistory = History.map((value, i, arr) => ({
          Text: this.$t('HistoryText')[i].Text,
          DefaultImg: History[i].DefaultImg,
          HoverImg: History[i].HoverImg,
          Year: this.$t('HistoryText')[i].Year,
          Month: this.$t('HistoryText')[i].Month,
          MarginTop: '10px',
          FontSize: '24px',
          LineHeight: '35px',
        }))
        // NewHistory.reverse();
        console.log(NewHistory)
        NewHistory.forEach((item, index, arr) => {
          if (item.Text.length === 1) {
            item.MarginTop = '30px'
          }
          if (item.Text.length < 5) {
            item.FontSize = '18px'
            item.LineHeight = '24px'
            item.MarginTop = '10px'
          }
          if (item.Text.length > 5) {
            item.FontSize = '18px'
            item.LineHeight = '24px'
            item.MarginTop = '0'
          }
        })
        return NewHistory
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped>
@import './style/AboutContent.min.css';
</style>



// WEBPACK FOOTER //
// src/components/about/AboutContent.vue